import styles from "./expensePayeeCardMobile.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";

const ExpensePayeeCardMobile = ({
  item,
  setDeleteModalOpen,
  setSelectecId,
  setEditModalOpen,
  setEditUserData,
  openDropdownId,
  setOpenDropdownId
}) => {

  const handleToggle = (id) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  }

  return (
    <>
      {/* <Link className={`${styles.ProspectCard}`}
        onClick={(e) => {
          if (item?.is_primary) return;
          setEditModalOpen(true);
          setEditUserData(item);
        }}
      >
        <div className={`${styles.ProspectCardUnder}`}>
          <div className={`${styles.ProspectCardHeadSection}`}>
            {!item?.is_primary && (
              <Dropdown
                className={`${styles.ActionLeaseBUSec}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <Dropdown.Toggle
                  className={`${styles.ActionsLeaseBU} ActionsBU`}
                  id="dropdown-basic"
                >
                  <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                  <Dropdown.Item
                    className={`${styles.EditActionsBUListItem}`}
                    onClick={(e) => {
                      setEditModalOpen(true);
                      setEditUserData(item);
                    }}
                  >
                    <Edit /> Edit
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                    onClick={(e) => {
                      setDeleteModalOpen(true);
                      setSelectecId(item.id);
                    }}
                  >
                    <Trash2 /> Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

            <div className={`${styles.ProsIMGSec}`}>
              <img src="/static/img/manage-payee.svg" alt="" />
            </div>
            <div className={`${styles.HeadConSec}`}>
              <p className={`${styles.ProsUserName}`}>
                <span className={`${styles.UserName}`}>{item?.company_name}</span>
              </p>
              <p className={`${styles.ProsUserName} ${styles.Small}`}>{item?.category?.title}</p>
            </div>
          </div>
          <div className={`${styles.ProspectCardFootSec}`}>
            <p className={`${styles.LeaseConDate}`}>
              {dayjs(item?.created_at).fromNow()}
            </p>
            <p className={`${styles.LeaseConDate}`}>
              Total paid amount: ${item?.paid_amount}
            </p>
          </div>
        </div>
      </Link> */}
      <div className={`${styles.MaintenanceReqCard}`}
        onClick={(e) => {
          if (item?.is_primary) return;
          setEditModalOpen(true);
          setEditUserData(item);
        }}
      >
        {!item?.is_primary && (
          <Dropdown className={`${styles.ActionLeaseBUSecSmall}`} show={openDropdownId === item.id} onToggle={() => handleToggle(item.id)} onClick={(e) => { e.stopPropagation(); }}>
            <Dropdown.Toggle className={`${styles.ActionsLeaseBUSmall} ActionsBU`} id="dropdown-basic">
              <MoreVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
              <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => { setEditModalOpen(true); setEditUserData(item); }}>
                <Edit /> Edit
              </Dropdown.Item>
              <Dropdown.Item className={`${styles.EditActionsBUListItemSmall} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
                <Trash2 /> Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        <div className={`${styles.CardImgSec} Secondary`}>
          <img src="/static/img/manage-payee.svg" alt="" />
        </div>
        <div className={`${styles.MainReCardCon}`}>
          <div>
            <div className={`${styles.MainReCardIdStatus}`}>
              <p className={`${styles.Title}`}>{item?.company_name}</p>
            </div>
            <div className={`${styles.MainReCardIdStatus}`}>
              <p className={`${styles.MainReID}`}>{item?.category?.title}</p>
            </div>
            <div className={`${styles.MainReCardIdStatusTwo}`}>
              <p className={`${styles.MainReID}`}>Total paid amount: ${item?.paid_amount}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpensePayeeCardMobile;
